import React, { Component } from 'react';

import Information from "../pages/Information";
import Changes from "../pages/Changes";
import '../css/app.css';
import CourseListPage from "../pages/Listing";
import ScrollingWrapper from "./ScrollingWrapper";
import Instructions from "../pages/Instructions";


class App extends Component {
    constructor(props) {
    super(props);
    this.state = {
        page: '#list'
    };
    this.handlePageNav = this.handlePageNav.bind(this);

  }

    handlePageNav( evt ) {
        let t = evt.target.getAttribute('href').substring(-1);
        this.setState({ page: t })
    }
  render() {
    return (
        <ScrollingWrapper>
        <div className="ndecourselister">
        <nav className="navbar is-primary" role="navigation" aria-label="main navigation">
            <div className="navbar-brand">
                <a className="navbar-item" href="/">
                    <img src="images/logo.png" width="112" height="28" alt="Nebraska Department of Education" />
                </a>

                <span role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false"
                   data-target="ndecccemenu">
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                    <span aria-hidden="true"></span>
                </span>
            </div>
            <div id="ndecccemenu" className="navbar-menu">
                <div className="navbar-start">
                    <a className={"navbar-item " + ( this.state.page === "#list" ? 'is-active' : '')} href='#list' onClick={this.handlePageNav}>
                        Course List
                    </a>

                    <a className={"navbar-item " + ( this.state.page === "#information" ? 'is-active' : '')} href='#info' onClick={this.handlePageNav}>
                        Information
                    </a>
                    <a className={"navbar-item " + ( this.state.page === "#changes" ? 'is-active' : '')} href='#changes' onClick={this.handlePageNav}>
                        Changes
                    </a>
                    <a className={"navbar-item " + ( this.state.page === "#instructions" ? 'is-active' : '')} href='#instructions' onClick={this.handlePageNav}>
                        Instructions
                    </a>
                </div>

                <div className="navbar-end">

                </div>
            </div>
        </nav>

            <div className="container">

                { this.state.page === "#list" ? <CourseListPage/> : ''}
                { this.state.page === "#info" ? <Information/> : ''}
                { this.state.page === "#changes" ? <Changes/> : ''}
                { this.state.page === "#instructions" ? <Instructions/> : ''}

            </div>
        </div>
        </ScrollingWrapper>
    );
  }
}

export default App;
